import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";

import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';
import { Compania } from '../Models/Compania';
import { TryCatchStmt } from '@angular/compiler';
import { Viaje } from '../Models/Viaje';
import { ViajeVisita } from '../Models/ViajeVisita';
import { ViajeVista } from '../Models/ViajeVista';
import { ViajeDetalle } from '../Models/ViajeDetalle';
import { ViajeContenedor } from '../Models/ViajeContenedor';
import { Pago } from '../Models/Pago';
import { ViajeReciboConforme } from '../Models/ViajeReciboConforme';
import { VisitaReciboConforme } from '../Models/VisitaReciboConforme';
import { ReportePagosEfectuados } from '../Models/ReportePagosEfectuados';
@Injectable()
export class ViajeService {

 
  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }

/**
 * Guarda el registro de viajeVisita
 * @param viajeVisita Objeto de tipo ViajeVisita
 */
    public GuardarRegistroViajeVisita(viajeVisita: ViajeVisita) {

      try {
  
        let params = JSON.stringify(viajeVisita);
  
        let url = this._utiles.getURL("viajevisita/viajeVisita");
  
        let headers = new Headers({ 'Content-Type': 'application/json' });
  
  
        let data: any;
  

        return this._http.post(url, viajeVisita, {headers: headers}).map(res => res.json());
  
      } catch (error) {
        console.log(error);
      }
  
  
    }

/**
 * Obtengo un resumen de los viajes en tiempo real para ser mostrados en el dashboard
 * @param compania Codigo de la compañia
 */
    ObtenerVistaViajes(compania: string): Observable<ViajeVista[]> {

      try {
  
        let url = this._utiles.getURL("visita/visitaTareaVista/" + compania );
  
  
        return this._http.get(url).map((response: Response) => {
          return <ViajeVista[]>response.json();
        });
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }

    /**
     * Obtiene un detalle viaje, obteniendo un estado de los visitas del viaje
     * @param compania Codigo de la compañia
     * @param idViaje Codigo del viaje
     */
    ObtenerViajeDetalle(compania: string,idViaje: string): Observable<ViajeDetalle[]> {

      try {
  
        let url = this._utiles.getURL("viaje/viajedetalle/" + compania+"/"+ idViaje );
  
  
        return this._http.get(url).map((response: Response) => {
          return <ViajeDetalle[]>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }
  /**
   * Obtengo el viaje por usuario
   * @param compania Codigo de la compañia
   * @param idUsuario Codigo de usuario
   */
    ObtenerViajesUsuario(compania: string,idUsuario: string): Observable<Viaje[]> {

      try {
  
        let url = this._utiles.getURL("viaje/usuario/" + compania+"/"+ idUsuario );
  
  
        return this._http.get(url).map((response: Response) => {
          return <Viaje[]>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }

/**
 * //Actualiza el viaje a fianalizado
//para el modulo para de forzar viaje
 * @param viaje Objeto de tipo Viaje
 */
    public ActualizarViajeFinalizado(viaje: Viaje) {

      try {
  
        let params = JSON.stringify(viaje);
  
        let url = this._utiles.getURL("viaje/anularviaje");
  
        let headers = new Headers({ 'Content-Type': 'application/json' });
  
  
        let data: any;
  

        return this._http.post(url, viaje, {headers: headers}).map(res => res.json());
  
      } catch (error) {
        console.log(error);
      }
  
  
    }


/**
 * actualiza el viaje a activo
 * viajevisita a activo
 * visitatarea a activo
 * @param viaje Objeto de tipo Viaje
 */
    public ActualizarReactivarViaje(viaje: Viaje) {

      try {
  
        let params = JSON.stringify(viaje);
  
        let url = this._utiles.getURL("viaje/reactivarviaje");
  
        let headers = new Headers({ 'Content-Type': 'application/json' });
  
  
        let data: any;
  

        return this._http.post(url, viaje, {headers: headers}).map(res => res.json());
  
      } catch (error) {
        console.log(error);
      }
  
  
    }

/**
 * Obtiene el viaje para la lista de de reavtivar viaje 
 * Cuando el estado del viaje y viajeVisita sean sincronizado
 * @param compania Codigo de la compañia
 * @param idUsuario Codigo del usuario
 */
    ObtenerViajesSincronizadosUsuario(compania: string,idUsuario: string): Observable<Viaje[]> {

      try {
  
        let url = this._utiles.getURL("viaje/chofersincronizado/" + compania+"/"+ idUsuario );
  
  
        return this._http.get(url).map((response: Response) => {
          return <Viaje[]>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }

/**
 * Obtiene todo el contenido del viaje por el contenedor
 * @param compania Codigo de la compañia
 * @param etiquetaContenedor Etiqueta compañia
 */
    ObtenerViajeContenedor(compania: string, etiquetaContenedor: string): Observable<ViajeContenedor> {

      try {
  
        let url = this._utiles.getURL("viaje/viajeetiqueta/" + compania+ '/' +etiquetaContenedor);
  
  
        return this._http.get(url).map((response: Response) => {
          return <ViajeContenedor>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }
/**
 * Obtiene los pagos por viaje
 * @param compania Codigo de la compañia
 * @param idViaje Codigo del viaje
 */
    ObtenerPagoViaje(compania: string, idViaje: string): Observable<ReportePagosEfectuados[]> {

      try {
  
        let url = this._utiles.getURL("Pago/pagoviaje/" + compania+ '/' +idViaje);
  
  
        return this._http.get(url).map((response: Response) => {
          return <ReportePagosEfectuados[]>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }

    /**
     * Obtiene el recibo conforme del viaje
     * @param compania Codigo de la compañia
     * @param idViaje Codigo del viaje
     */
    ObtenerViajeReciboConforme(compania: string, idViaje: string): Observable<ViajeReciboConforme> {

      try {
  
        let url = this._utiles.getURL("viaje/viajeReciboConforme/" + compania+ '/' +idViaje);
  
  
        return this._http.get(url).map((response: Response) => {
          return <ViajeReciboConforme>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }

    /**
     * Obtiene todas las visitas con un contador de bultos del viaje
     * @param compania Codigo de la compañia
     * @param idViaje Codigo del viaje 
     */
    ObtenerVisitaReciboConforme(compania: string, idViaje: string): Observable<VisitaReciboConforme[]> {

      try {
  
        let url = this._utiles.getURL("viaje/visitasReciboConforme/" + compania+ '/' +idViaje);
  
  
        return this._http.get(url).map((response: Response) => {
          return <VisitaReciboConforme[]>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }

/**
 * Obtiene todas las sumas y contadores por viaje para el footer del reporte viaje recibo conforme
 * @param compania 
 * @param idViaje 
 */
    ObtenerVisitaReciboConformeSumas(compania: string, idViaje: string): Observable<VisitaReciboConforme[]> {

      try {
  
        let url = this._utiles.getURL("viaje/visitasReciboConformeSumas/" + compania+ '/' +idViaje);
  
  
        return this._http.get(url).map((response: Response) => {
          return <VisitaReciboConforme[]>response.json();
        });

      } catch (error) {
  
        console.log(error);
      }
  
    }


    ObtenerReportePagosEfectudos(compania: string, idUsuario: string, fechaInicio:Date,fechaFin:Date,
       numeroDocumento: string,codigoCliente:string, tipoTarea: string): Observable<ReportePagosEfectuados[]> {

      try {
  
        let url = this._utiles.getURL("pago/reportePagosEfectuados/" + compania+ '/' +idUsuario+ '/'+
         fechaInicio+ '/' +fechaFin+ '/'+ numeroDocumento + '/'+ codigoCliente+ '/'+ tipoTarea);
  
  
        return this._http.get(url).map((response: Response) => {
          return <ReportePagosEfectuados[]>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }


    ObtenerViajeSincronizado(compania: string, idUsuario: string): Observable<Viaje> {

      try {
  
        let url = this._utiles.getURL("viaje/viajeSincronizado/" + compania+ '/' +idUsuario);
  
  
        return this._http.get(url).map((response: Response) => {
          return <Viaje>response.json();
        });
  
  
  
      } catch (error) {
  
        console.log(error);
      }
  
    }

  }
